import { IS_LOADING, SET_DATA_ID, SET_DATA_ITEM, SET_DATA_LIST, SET_ERROR, SET_SUCCESS, SET_TOTAL } from "@/store/Crud/functions/mutations";
export function SET_VALIDITY(state, data) {
    state.validity = data;
}
export function SET_CAN_USE_KI_PILOT_THEORY(state, data) {
    state.canUseKiPilotTheory = data;
}
export function SET_YOUTUBE_LINK(state, data) {
    state.youtubeLink = data;
}
export function SET_PRAXIS_OVERVIEW(state, data) {
    state.praxisOverview = data;
}
// KI-Pilot Theory explanations
export function SET_EXPLANATION_LOADING(state, loading) {
    state.explanationLoading = loading;
}
export function SET_EXPLAIN_VOLUME(state, data) {
    state.explainVolume = data;
}
export function SET_EXPLAIN_PRE_EXAM_PERFORMANCE(state, data) {
    state.explainPreExamPerformance = data;
}
export function SET_EXPLAIN_PERFORMANCE(state, data) {
    state.explainPerformance = data;
}
export function SET_EXPLAIN_GENERAL_OVERVIEW(state, data) {
    state.explainGeneralOverview = data;
}
export function SET_EXPLAIN_CATEGORY(state, data) {
    state.explainCategory = data;
}
export default {
    IS_LOADING,
    SET_ERROR,
    SET_SUCCESS,
    SET_DATA_ITEM,
    SET_DATA_ID,
    SET_DATA_LIST,
    SET_TOTAL,
    SET_VALIDITY,
    SET_CAN_USE_KI_PILOT_THEORY,
    SET_YOUTUBE_LINK,
    SET_PRAXIS_OVERVIEW,
    SET_EXPLANATION_LOADING,
    SET_EXPLAIN_VOLUME,
    SET_EXPLAIN_PRE_EXAM_PERFORMANCE,
    SET_EXPLAIN_PERFORMANCE,
    SET_EXPLAIN_GENERAL_OVERVIEW,
    SET_EXPLAIN_CATEGORY,
};
